import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { withStyles, useMediaQuery } from '@material-ui/core';
import { Dialog, Button, Icon } from 'components/Ui';
import { translateValues } from 'utils/translation';

import MUIStyles from '../BrandSwitchDialog/styles';
import styles from '../BrandSwitchDialog/styles.scss';

const formatText = (exp, text, value) => text.replace(exp, value);
// HINT: Update french translations in contentful JSON Data.
//       To be more specific about translations, you may want to
//       add Translation Keys instead of the English Text below.
const locale = translateValues({
  // HINT: Translation Key: `Default Value`.
  CannotCancel_Title: `Confirm`,
  CannotCancel_Message: `You are ordering {productName} and it will ship via a third-party carrier. You can not cancel this order once placed.`,
  CannotCancel_PleaseConfirm: `Please click {confirm} button to proceed.`,
  CannotCancel_ConfirmButton: `Yes, Continue`,
});

const CannotCancelDialog = ({ open, item, onContinue, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      size="small"
      open={open}
      item={item}
      isCloseIcon
      fullScreen={isMobile}
      onClose={onClose}
    >
      <div className={styles.container}>
        <Icon icon="shopping-cart" />
        <span className={styles.title}>{locale.CannotCancel_Title}</span>
        <div className={styles.text}>
          <p>
            {formatText(
              '{productName}',
              locale.CannotCancel_Message,
              item.name,
            )}
          </p>
          <p>
            {formatText(
              '{confirm}',
              locale.CannotCancel_PleaseConfirm,
              locale.CannotCancel_ConfirmButton,
            )}
          </p>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            onClick={onContinue}
            text={locale.CannotCancel_ConfirmButton}
            className={styles.btn}
            type="button"
          />
        </div>
      </div>
    </Dialog>
  );
};

export default withStyles(MUIStyles, { withTheme: true })(CannotCancelDialog);
